import React, { useState } from 'react';

const Comment = ({ proposal, onClose, userName = 'Current User' }) => {
  const [comments, setComments] = useState([
    { text: 'This looks good to me!', user: 'John Doe', timestamp: '10:15 AM' },
    {
      text: 'Could we update the supplier info?',
      user: 'Jane Smith',
      timestamp: '10:30 AM',
    },
    {
      text: "Sure, I'll make the changes.",
      user: userName,
      timestamp: '10:45 AM',
    },
  ]);

  const [newComment, setNewComment] = useState('');

  const handleAddComment = () => {
    if (newComment.trim() === '') return;
    setComments([
      ...comments,
      {
        text: newComment,
        user: userName,
        timestamp: new Date().toLocaleTimeString(),
      },
    ]);
    setNewComment('');
  };

  return (
    <div className="pl-72 fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-lg p-6 rounded-lg shadow-2xl relative transition-transform transform scale-100 hover:scale-105">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 transition duration-200"
          aria-label="Close"
        >
          &times;
        </button>

        {/* Header */}
        <h2 className="text-2xl font-bold text-gray-800 mb-4 font-700">
          Proposal Info
        </h2>

        {/* Proposal Information (Compact and Polished) */}
        <div className="space-y-1 mb-6 text-gray-600 text-sm flex justify-between">
          <div>
            <p className=" p-1">
              <span className="font-semibold text-gray-700">Proposal No:</span>{' '}
              {proposal?.id}
            </p>
            <p className=" p-1">
              <span className="font-semibold text-gray-700">Customer:</span>{' '}
              {proposal?.customerName}
            </p>
          </div>
          <div>
            <p className=" p-1">
              <span className="font-semibold text-gray-700">Date:</span>{' '}
              {proposal?.date}
            </p>
            <p className=" p-1">
              <span className="font-semibold text-gray-700">Supplier:</span>{' '}
              {proposal?.supplier}
            </p>
            <p className=" p-1">
              <span className="font-semibold text-gray-700">Sales Person:</span>{' '}
              {proposal?.salesPerson}
            </p>
          </div>
        </div>

        {/* Comments Section (Expanded and Polished) */}
        <div className="border-t pt-4">
          <h3 className="text-lg font-semibold text-gray-800 mb-3">Comments</h3>
          <div className="space-y-3 max-h-64 overflow-y-auto mb-4 pr-2">
            {comments.map((comment, index) => (
              <div
                key={index}
                className={`flex items-start ${
                  comment.user === userName ? 'justify-end' : 'justify-start'
                }`}
              >
                <div
                  className={`p-3 rounded-lg shadow-sm max-w-xs ${
                    comment.user === userName
                      ? 'bg-blue-100 text-blue-900'
                      : 'bg-gray-100 text-gray-800'
                  }`}
                >
                  <p className="text-sm font-semibold mb-1">{comment.user}</p>
                  <p className="text-sm">{comment.text}</p>
                  <p className="text-xs text-gray-500 mt-2">
                    {comment.timestamp}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Input Field and Button for Adding New Comment */}
          <div className="flex items-center gap-2 border-t pt-4">
            <input
              type="text"
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              className="flex-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-700"
              placeholder="Write a comment..."
            />
            <button
              onClick={handleAddComment}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition duration-200"
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Comment;
